import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02407338"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main"
}
const _hoisted_2 = { class: "fault-info-block" }
const _hoisted_3 = {
  key: 1,
  class: "empty-text"
}
const _hoisted_4 = { class: "media-info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "附件(故障视频、飞行日志文件等)", -1))
const _hoisted_6 = {
  key: 0,
  class: "description-text"
}
const _hoisted_7 = {
  key: 1,
  class: "empty-text"
}
const _hoisted_8 = { class: "xag-ellipsis" }
const _hoisted_9 = { class: "fault-info-block" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "故障日志", -1))
const _hoisted_11 = {
  key: 0,
  class: "log-list van-hairline--top"
}
const _hoisted_12 = { class: "rang" }
const _hoisted_13 = { class: "time" }
const _hoisted_14 = {
  key: 1,
  class: "empty-text"
}
const _hoisted_15 = { class: "fault-info-block" }
const _hoisted_16 = { class: "boom-info" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "是否炸机", -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "empty-text"
}

import { useRoute, useRouter } from 'vue-router'
import { Ref, ref, reactive, onMounted, computed } from 'vue'
import { commonErrorHandle } from '@/utils/error-handle'
import { clearToast, showToastLoading } from '@/utils/tools'
import {
  useMalfunctionRepairStore,
  useMalfunctionRepairAddressInfo,
  useMalfunctionRepairOrderDetailInfo,
} from '@/compositions/malfunction-repair/index'
import AppHeader from '@/components/Header.vue'
import CellWrap from './components/cell-wrap.vue'
import CommonImagePreview from '@/components/CommonImagePreview.vue'
import UploadFile, {judgeMp4} from '@/components/upload/newUploadFIle.vue'
import { useImageGuidTransfer } from '@/compositions/common'
import type { CommonUploaderFileListItem } from '@/types/public'

export default /*#__PURE__*/_defineComponent({
  __name: 'service-order-apply-info',
  setup(__props) {

const $router = useRouter()
const $route = useRoute()

const is_uav = ($route.query.is_uav as string) === 'true'
const guid = $route.query.guid as string
const { getOrderApplyInfo, setOrderDetailAddressInfo } = useMalfunctionRepairStore()
const { getOrderDetail } = useMalfunctionRepairOrderDetailInfo()
const { getAddressStr } = useMalfunctionRepairAddressInfo()
const isInited = ref(false)
const addressDetail = ref('')
const imageGuids: Ref<string[]> = ref([])
let formData = reactive({
  guid: guid,
  description: '',
  is_boom: 0,
  logs: [],
  annextList: [] as CommonUploaderFileListItem[],
  isPay: 0
})

const isPay =computed(()=>{
  return formData.isPay === 1
})

let setFileList: Function
const { getImageFullUrl } = useImageGuidTransfer()

async function annextHandle(annextList:CommonUploaderFileListItem[]) {
  try {
    const data = await getImageFullUrl((annextList.map(_ => _.url)))
    console.log('annextHandle', data)
    formData.annextList = formData.annextList.map((val) => {
      console.log('judgeMp4(val.url)',judgeMp4(data[val.url].url),data[val.url].url)
      return {
      ...val,
      status: 'done',
      url: data[val.url].url,
      isVideo:judgeMp4(data[val.url].url)
    }
    })
    console.log('dddd',formData.annextList)
  } catch (error) {
    console.log('error', error)
    formData.annextList = formData.annextList.map(_ => {
      return {
        ..._,
        status:'failed'
      }
    })
  }
  console.log('setFileList',setFileList)
  setFileList && setFileList(formData.annextList)
}

async function initData() {
  showToastLoading()
  try {
    let data = await getOrderApplyInfo(guid)
    let orderDetail = await getOrderDetail(guid)
    formData.description = data.description
    formData.logs = data.logs
    formData.is_boom = data.is_boom
    imageGuids.value = data.images ||[]
    formData.isPay = data.is_pay
    const addressInfo = orderDetail.logistics
    addressDetail.value = getAddressStr(addressInfo)
    setOrderDetailAddressInfo(orderDetail.logistics)
    clearToast()
    // 附件图片处理
    formData.annextList = (orderDetail.annex ||[]).map(_ => {
      return {
        ..._,
        status: 'uploading',
        isVideo: false
      }
    })
    annextHandle(formData.annextList)
  } catch (error) {
    commonErrorHandle(error)
  }
  isInited.value = true
}

function toEditAddress() {
  $router.push({
    name: 'malfunction-repair-fault-address',
    query: {
      check: '1',
    },
  })
}

function uploadFileInitHandle (data:{setFileList:Function}){
  console.log('uploadFileInitHandle',data)
  setFileList= data.setFileList
}
onMounted(() => {
  initData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "提单内容" }),
    (isInited.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["media-info", {'row-info': !imageGuids.value.length}])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass({'red-star':!_unref(isPay)})
              }, "故障照片", 2),
              (imageGuids.value.length)
                ? (_openBlock(), _createBlock(CommonImagePreview, {
                    key: 0,
                    guids: imageGuids.value
                  }, null, 8, ["guids"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, "无"))
            ], 2),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(UploadFile, {
                maxCount: 3,
                defaultList: _unref(formData).annextList,
                onInit: uploadFileInitHandle,
                showUpload: false,
                deletable: false
              }, null, 8, ["defaultList"])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["description van-hairline--top", {'row-info': !_unref(formData).description.length}])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass({'red-star':!_unref(isPay)})
              }, "故障描述", 2),
              (_unref(formData).description.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(formData).description), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, "无"))
            ], 2)
          ]),
          _createVNode(CellWrap, {
            label: "回寄地址",
            style: {"margin-bottom":"12px"},
            fillColor: "rgba(0, 0, 0, 0.44)",
            onClick: toEditAddress
          }, {
            "cell-right": _withCtx(() => [
              _createElementVNode("div", _hoisted_8, _toDisplayString(addressDetail.value), 1)
            ]),
            _: 1
          }),
          is_uav
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["log-info", {'log-row-info':_unref(isPay)}])
                  }, [
                    _hoisted_10,
                    (!_unref(isPay))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formData).logs, (log) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "log-item",
                              key: log.guid
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["boom-label", log.isBoom ? '' : 'unboom-label'])
                              }, _toDisplayString(log.isBoom ? '' : '未') + "检测到炸机 ", 3),
                              _createElementVNode("div", _hoisted_12, _toDisplayString(log.name), 1),
                              _createElementVNode("div", _hoisted_13, "时长 " + _toDisplayString(log.longStr), 1)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14, "无"))
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    (!_unref(isPay))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(formData).is_boom === 1 ? '' : '未') + "发生炸机", 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_19, "无"))
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})